var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"container-fluid"},[_c('global-rich-text',{attrs:{"payload":_vm.currentText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }